export enum ButtonType {
  BUTTON = 'button',
  SUBMIT = 'submit',
  RESET = 'reset',
}

export enum ButtonFontSize {
  SMALL = 'small',
}

export const buttonTypeKeys = Object.keys(ButtonType);
export const buttonTypeValues = buttonTypeKeys.map((target) => ButtonType[target]);

export enum ButtonAppearance {
  PRIMARY_GREY = 'primary-grey',
  PRIMARY_YELLOW = 'primary-yellow',
  PRIMARY_LIGHT_GREY = 'primary-light-grey',
  SECONDARY_GREY = 'secondary-grey',
  SECONDARY_WHITE = 'secondary-white',
  TERTIARY = 'tertiary',
  NAVIGATION_TAB = 'navigation-tab',
  CLEAR = 'clear',
  CATEGORY = 'category',
  UNDERLINE_ICON = 'underline-icon',
  FILTER = 'filter',
  FILTER_LIGHT = 'filter-light',
  MODAL_CLOSE = 'modal-close',
  GLOBAL_SEARCH = 'global-search',
  DEFAULT = 'default',
  MOBILE_SUBMENU_CLOSED = 'mobile-submenu-closed',
  MOBILE_SUBMENU_OPEN = 'mobile-submenu-opened',
  CLEAR_INPUT = 'clear-input',
}

export enum ButtonTheme {
  DARK = 'dark',
  LIGHT = 'light',
}

export const buttonAppearanceKeys = Object.keys(ButtonAppearance);
export const buttonAppearanceValues = buttonAppearanceKeys.map((appearance) => ButtonAppearance[appearance]);

export interface RcmDownloadProp {
  src: string;
  caption?: string;
  copyright?: string;
  alt?: string;
  title?: string;
}
